export default __webpack_public_path__ + "static/media/budget(1).8d47421a.png";